var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "career" }, [
    _c("div", { staticClass: "profile-field__title" }, [_vm._v("Карьера")]),
    _vm.field.career.medicalBook
      ? _c(
          "div",
          { staticClass: "medical-book" },
          [
            _c("c-switcher", {
              attrs: { label: "Есть медицинская книжка" },
              model: {
                value: _vm.hasMedicalBook,
                callback: function ($$v) {
                  _vm.hasMedicalBook = $$v
                },
                expression: "hasMedicalBook",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "row align-items-end",
        class: {
          "salary-error": _vm.error && _vm.error.salary,
          "work-start-error": _vm.error && _vm.error.startDate,
        },
      },
      [
        _vm.field.career.salaryShow
          ? _c("div", { staticClass: "col col-12 col-md-2 salary" }, [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    "is-invalid": _vm.error && _vm.error.salary,
                  },
                },
                [
                  _c("c-input", {
                    attrs: {
                      label: "Желаемая зарплата, ฿",
                      clearable: true,
                      placeholder: "0",
                      type: "price-number",
                      split: true,
                      "fractional-length": 0,
                      "required-mark": _vm.field.career.salaryRequired,
                      invalid: _vm.error && _vm.error.salary,
                      error: _vm.error && _vm.error.salary,
                    },
                    model: {
                      value: _vm.salary,
                      callback: function ($$v) {
                        _vm.salary = $$v
                      },
                      expression: "salary",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.field.career.schedule.show
          ? _c("div", { staticClass: "col col-12 col-md-2 schedule" }, [
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c("c-select", {
                    attrs: {
                      type: "select",
                      label: "Желаемый график работы",
                      placeholder: "Любой",
                      searchable: true,
                      items: _vm.options,
                      clearable: true,
                      "custom-options": _vm.field.career.schedule.custom,
                    },
                    model: {
                      value: _vm.schedule,
                      callback: function ($$v) {
                        _vm.schedule = $$v
                      },
                      expression: "schedule",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.field.career.workStartShow
          ? _c("div", { staticClass: "col cols-12 col-md-2 work-start" }, [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    "is-invalid": _vm.error && _vm.error.startDate,
                  },
                },
                [
                  _c("c-input", {
                    ref: "date",
                    attrs: {
                      type: "date",
                      placeholder: "00.00.0000",
                      label: "Когда сможете приступить к работе",
                      icon: "calendar",
                      clearable: true,
                      editable: true,
                      "icon-right": true,
                      "required-mark": _vm.field.career.workStartRequired,
                      required: _vm.error && _vm.error.startDate,
                      "required-message": _vm.error && _vm.error.startDate,
                    },
                    model: {
                      value: _vm.startDate,
                      callback: function ($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }